import type { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import Forbidden from "../pages/Forbidden";
import { usePermissions } from "src/hooks/usePermissions";

interface TemplateGuardProps {
  children: ReactNode;
}

const RecordingsGuard: FC<TemplateGuardProps> = ({ children }) => {
  const { recordingsEnabled } = usePermissions();

  if (!recordingsEnabled) {
    return <Forbidden />;
  }

  return <>{children}</>;
};

RecordingsGuard.propTypes = {
  children: PropTypes.node,
};

export default RecordingsGuard;